/** @jsxImportSource theme-ui */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import LocationApi from 'api/LocationApi';

import { BdAdditiveLocationSearch } from 'components/_controls/AoiSearch/BdAdditiveLocationSearch';

import { addLocation } from 'locations/locations.saga';
import locationsSelectors from 'locations/locations.selectors';

/** This component is a redux wrapper for the generic BdAdditiveLocationSearch control */
export const LocationSearch: React.FC = () => {
  const dispatch = useDispatch();

  const allLocationIds = useSelector(locationsSelectors.getAllLocationIds);
  const isAddingLocation = useSelector(locationsSelectors.isAddingLocation);

  return (
    <BdAdditiveLocationSearch
      onSearchApiCall={LocationApi.searchLocations}
      selectedItemIds={allLocationIds}
      onAddItem={({ id }) => dispatch(addLocation(id))}
      isAddInProgress={isAddingLocation}
      bottomBorderOnly
    />
  );
};
